// @ts-nocheck
import React from 'react';
import CreateEventForm from '@/components/admin-dashboard/CreateEventForm';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const DemoCreateEvent: React.FC = () => {
  const navigate = useNavigate();

  const handleEventCreated = () => {
    toast.success('Demo event created successfully!');
    navigate('/demo/hub');
  };

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-foreground">Create New Event</h1>
        <p className="text-muted-foreground">Build a new event with full registration, pricing, and tournament configuration</p>
      </div>
      <CreateEventForm onEventCreated={handleEventCreated} />
    </div>
  );
};

export default DemoCreateEvent;
